import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { PaginationState } from '@tanstack/react-table';
import { useMutation, useQuery } from 'data/utils/useQuery';
import { FileStorageControllerService } from 'data/openapi';
import { FileType } from 'data/types';
import { QueryKeys } from 'data/constants';

export const useUploadFile = (options?: UseMutationOptions<void, any, any, any>) => {
  return useMutation(async ({ fileType, files }: { fileType: FileType; files: File[] }) => {
    // to be able to work with openapi method 'upload' it should support 'formData' option instead of 'body' option
    await FileStorageControllerService.createFile(fileType, { files: files as Blob[] });
  }, options);

  // custom fetch request to upload dar file
  // return useMutation(async ({ file, keycloak }: { file: File; keycloak: Keycloak }) => {
  //   const { requestPath } = useDataConfig();
  //
  //   const formData = new FormData();
  //   formData.append('file', file);
  //
  //   await fetch(requestPath(`files`), {
  //     method: 'POST',
  //     body: formData,
  //     headers: { authorization: 'Bearer ' + keycloak.token },
  //   });
  // }, options);
};

export const useFiles = (fileType: FileType, isEnabled: boolean, pagination?: PaginationState, name?: string) => {
  let from: number | undefined;
  let limit: number | undefined;
  if (pagination) {
    const { pageSize, pageIndex } = pagination as PaginationState;
    from = !name ? pageIndex : 0;
    limit = pageSize;
  }
  return useQuery(
    [QueryKeys.FILES, fileType, from, limit, name],
    () => FileStorageControllerService.listFiles(fileType, from && limit ? from * limit : undefined, limit, name),
    {
      enabled: isEnabled,
      keepPreviousData: true,
      select: ({ files, totalCount }) => {
        const list =
          files?.map((el) => {
            return {
              value: el.name,
              label: el.name,
              ...el,
            };
          }) ?? [];

        return { files: list, totalCount };
      },
    },
  );
};

export const useDeleteFile = (fileType: FileType, onSuccessFn?: (name: string) => void) => {
  const queryClient = useQueryClient();

  const fileInvalidation = () => {
    queryClient.invalidateQueries([QueryKeys.FILES, fileType]);
  };

  return useMutation(
    async (name: string) => {
      await FileStorageControllerService.deleteFile(name, fileType);
      return name;
    },
    {
      onSuccess: (name: string) => {
        if (onSuccessFn) onSuccessFn(name);
      },
      onSettled: fileInvalidation,
    },
  );
};
